import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import CustomerVehicleHireStatusType from "../common/enum/CustomerVehicleHireStatusType";
import API from "../../services/API";

interface VehicleHireDocketDownloadButtonProps {
    vehicleHire: CustomerAPIVehicleHire
}

const VehicleHireDocketDownloadButton = (
    props: VehicleHireDocketDownloadButtonProps
) => {

    const openWindow = (e: React.MouseEvent) => {
        e.stopPropagation();
        window.open(`${API.ORIGIN}/customer/v1/vehicle-hires/${vehicleHire.id}/documents/docket`);
    };

    const { vehicleHire } = props;
    const status = CustomerVehicleHireStatusType.valueOf(vehicleHire.status);
    if (status !== CustomerVehicleHireStatusType.COMPLETED) {
        return null;
    }
    return (
        <button
            className="btn btn-outline-primary"
            onClick={openWindow}>
            Completion Docket <FontAwesomeIcon icon={faDownload} />
        </button>
    )

}

export default VehicleHireDocketDownloadButton;
